/**
 * @generated SignedSource<<7c98947e060ab122b0edbdd3df3d3e86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimelineItemsViewer$data = {
  readonly login: string;
  readonly " $fragmentType": "TimelineItemsViewer";
};
export type TimelineItemsViewer$key = {
  readonly " $data"?: TimelineItemsViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimelineItemsViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimelineItemsViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4b920962801d16865316778e1e532f65";

export default node;
